import React from 'react';
import { observer } from 'mobx-react-lite';
import { HomeData } from '../../../api/types/home-data/home-data';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import { DocFeedbackStatusDB } from '../../../api/types/docs/doc-feedback-status';

interface AboutHomePageProps {
  homeData: HomeData | null;
  currentUser: UserSummaryType | null;
}

const AboutHomePage: React.FC<AboutHomePageProps> = observer(
  ({ homeData, currentUser }) => {
    const getRowItem = (text: string, iconClass: string) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <i
            className={iconClass}
            style={{ fontSize: '20px', color: '#185FD3' }}
          />
          <div style={{ width: '20px' }} />
          <div style={{ color: '#3D424D', fontSize: '14px' }}>{text}</div>
        </div>
      );
    };

    // Calculate waiting documents count
    const waitingDocsCount =
      homeData?.docs?.filter((doc) => {
        if (doc.feedbacks.length === 0) {
          return true; // No feedback means it's waiting
        }
        const lastFeedback = doc.feedbacks[doc.feedbacks.length - 1];
        return (
          lastFeedback.status === DocFeedbackStatusDB.Init ||
          lastFeedback.status === DocFeedbackStatusDB.Reject
        );
      }).length || 0;

    // Calculate pending working hours count
    const pendingWorkingHoursCount =
      homeData?.pendingWorkingHours?.filter(
        (item) => item.status === 'pendingForApproval',
      ).length || 0;

    // Calculate total lectures count
    const lecturesCount = homeData?.lectures?.length || 0;

    // Get user greeting
    const getUserGreeting = () => {
      if (currentUser) {
        return `שלום, ${currentUser.firstName} ${currentUser.lastName}`;
      }
      return 'שלום,';
    };

    return (
      <div
        style={{
          backgroundColor: '#ffffff',
          padding: '20px',
          height: '100%',
          borderRadius: '12px',
        }}
      >
        <div
          style={{ paddingBottom: '10px', color: '#185FD3', fontSize: '18px' }}
        >
          {getUserGreeting()}
        </div>
        <div style={{ marginTop: '12px', color: '#3D424D', fontSize: '16px' }}>
          מחכים לך:
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '180px',
            paddingTop: '20px',
            paddingBottom: '20px',
          }}
        >
          {getRowItem(
            `${waitingDocsCount} מסמכים ממתינים לאישור`,
            'pi pi-file',
          )}
          {getRowItem(
            `${pendingWorkingHoursCount} דיווחי שעות לאישור`,
            'pi pi-clock',
          )}
          {getRowItem(`${lecturesCount} הרצאות`, 'pi pi-users')}
          {/*{getRowItem('עדכונים נוספים', 'pi pi-bell')}*/}
        </div>
      </div>
    );
  },
);

export default AboutHomePage;
